import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAdminToken = () => localStorage.getItem("maati_admin_token") || "";
const adminHeaders = () => ({ "X-Admin-Token": getAdminToken() });

// Public
export const fetchRecipes = async (spiceSlug) => {
  const params = spiceSlug && spiceSlug !== "all" ? { spice: spiceSlug } : {};
  const { data } = await axios.get(`${API}/recipes`, { params });
  return data;
};

export const fetchRecipe = async (slug) => {
  const { data } = await axios.get(`${API}/recipes/${slug}`);
  return data;
};

// Admin
export const adminVerify = async (token) => {
  await axios.post(
    `${API}/admin/verify`,
    {},
    { headers: { "X-Admin-Token": token } },
  );
  return true;
};

export const createRecipe = async (payload) => {
  const { data } = await axios.post(`${API}/recipes`, payload, {
    headers: adminHeaders(),
  });
  return data;
};

export const updateRecipe = async (slug, payload) => {
  const { data } = await axios.put(`${API}/recipes/${slug}`, payload, {
    headers: adminHeaders(),
  });
  return data;
};

export const deleteRecipe = async (slug) => {
  const { data } = await axios.delete(`${API}/recipes/${slug}`, {
    headers: adminHeaders(),
  });
  return data;
};
